/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18.9975 5.0025c1.3367 1.3366 1.3367 3.5037 0 4.8404L8.8405 20H4v-4.8404L14.1571 5.0025c1.3366-1.3367 3.5038-1.3367 4.8404 0Zm-1.0672 1.0672c-.7472-.7472-1.9587-.7472-2.706 0l-6.5591 6.5592 2.7059 2.7059 6.5592-6.5591c.7472-.7473.7472-1.9588 0-2.706Zm-7.6264 10.3324-2.706-2.706-2.0886 2.0886v2.706h2.706l2.0886-2.0886Z"
    clipRule="evenodd"
  />,
  'EditPen'
);
